function generatePrimaryBadgeHTML(product) {
  const {
    id,
    tags = [],
    availableForSale,
    selectedOrFirstAvailableVariant: {
      price,
      compareAtPrice,
    }
  } = product;

  const productId = id.replace('gid://shopify/Product/', '');
  let badgeHTML = '';

  // Check for Coming Soon (PREORDER + not available)
  const isComingSoon = !availableForSale && tags.includes('PREORDER');
  
  // Check for Backorder (BACKORDER + available)
  const isBackorder = availableForSale && tags.includes('BACKORDER');

  // Check for Preorder (PREORDER + available)
  const isPreorder = availableForSale && tags.includes('PREORDER');

  // Sale Badge - Calculate discount percentage
  if (compareAtPrice && +compareAtPrice.amount > +price.amount) {
    const discountPercentage = Math.round(
      ((+compareAtPrice.amount - +price.amount) / +compareAtPrice.amount) * 100
    );
    
    if (discountPercentage > 0) {
      badgeHTML += `
        <style>
          .card__badge--${productId} .badge--sale {
            box-shadow: -4px -4px var(--badge-badge--sale-bg, #fd5a46);
          }
          .card__badge--${productId} .badge--sale::before,
          .card__badge--${productId} .badge--sale::after {
            border-top: 3px solid var(--badge-badge--sale-bg, #fd5a46);
          }
        </style>
        <div class="card__badge__item">
          <span class="badge badge--custom badge--sale" style="background-color: var(--badge-badge--sale-bg, #fd5a46); color: var(--badge-badge--sale-text, #FFFFFF);">
            <p>${discountPercentage}% off</p>
          </span>
        </div>
      `;
    }
  }

  if (isComingSoon) {
    badgeHTML += `
      <style>
        .card__badge--${productId} .badge--coming-soon {
          box-shadow: -4px -4px var(--badge-comingsoon-bg, #00c389);
        }
        .card__badge--${productId} .badge--coming-soon::before,
        .card__badge--${productId} .badge--coming-soon::after {
          border-top: 3px solid var(--badge-comingsoon-bg, #00c389);
        }
      </style>
      <div class="card__badge__item">
        <span class="badge badge--custom badge--coming-soon" style="background-color: var(--badge-comingsoon-bg, #00c389); color: var(--badge-comingsoon-text, #FFFFFF);">
          Coming soon
        </span>
      </div>
    `;
  } else if (isBackorder) {
    badgeHTML += `
      <style>
        .card__badge--${productId} .badge--backorder {
          box-shadow: -4px -4px var(--badge-backorder-bg, #150202);
        }
        .card__badge--${productId} .badge--backorder::before,
        .card__badge--${productId} .badge--backorder::after {
          border-top: 3px solid var(--badge-backorder-bg, #150202);
        }
      </style>
      <div class="card__badge__item">
        <span class="badge badge--custom badge--backorder" style="background-color: var(--badge-backorder-bg, #150202); color: var(--badge-backorder-text, #0C8BED);">
          Backorder
        </span>
      </div>
    `;
  } else if (isPreorder) {
    badgeHTML += `
      <style>
        .card__badge--${productId} .badge--preorder {
          box-shadow: -4px -4px var(--badge-preorder-bg, #00c389);
        }
        .card__badge--${productId} .badge--preorder::before,
        .card__badge--${productId} .badge--preorder::after {
          border-top: 3px solid var(--badge-preorder-bg, #00c389);
        }
      </style>
      <div class="card__badge__item">
        <span class="badge badge--custom badge--preorder" style="background-color: var(--badge-preorder-bg, #00c389); color: var(--badge-preorder-text, #FFFFFF);">
          PREORDER
        </span>
      </div>
    `;
  }

  if (tags.includes('badge--casual')) {
    badgeHTML += `
      <style>
        .card__badge--${productId} .badge--casual {
          box-shadow: -4px -4px var(--badge-badge--casual-bg, #ffc845);
        }
        .card__badge--${productId} .badge--casual::before,
        .card__badge--${productId} .badge--casual::after {
          border-top: 3px solid var(--badge-badge--casual-bg, #ffc845);
        }
      </style>
      <div class="card__badge__item">
        <span class="badge badge--custom badge--casual" style="background-color: var(--badge-badge--casual-bg, #ffc845); color: var(--badge-badge--casual-text, #1E2C48);">
          CASUAL
        </span>
      </div>
    `;
  }

  return badgeHTML;
}

/**
 * Standardizes tag names to match Shopify's handle filter behavior
 * Converts "BGG Top 100" to "bgg-top-100" for valid CSS variable names
 */
function standardizeTagForCSS(tag) {
  return tag
    .toLowerCase()
    .replace(/\s+/g, '-')           // Replace spaces with hyphens
    .replace(/_/g, '-')              // Replace underscores with hyphens
    .replace(/[^a-z0-9-]/g, '')     // Remove special characters except hyphens
    .replace(/-+/g, '-')             // Replace multiple hyphens with single hyphen
    .replace(/^-|-$/g, '');          // Remove leading/trailing hyphens
}

function generateSecondaryBadgeHTML(product) {
  const { tags = [] } = product;

  let badgeHTML = '';
  
  // Use window.secondaryBadges if available
  // @ts-ignore - secondaryBadges is defined in badge-colors-css.liquid
  const secondaryBadges = window.secondaryBadges || [];
  
  tags.forEach((productTag) => {
    const matchingBadge = secondaryBadges.find((badge) => badge.tag === productTag);
    
    if (matchingBadge) {
      const { tag, title } = matchingBadge;
      const cssVarName = standardizeTagForCSS(tag);
      badgeHTML += `
        <div class="card__secondary-badge__item">
          <span class="secondary-badge secondary-badge--custom" style="background-color: var(--badge-${cssVarName}-bg); color: var(--badge-${cssVarName}-text);">
            ${title}
          </span>
        </div>
      `;
    }
  });

  return badgeHTML;
}

const PRODUCT_CARD_HTML = ({
  title,
  handle,
  availableForSale,
  featuredImage,
  selectedOrFirstAvailableVariant: {
    id: variant_id,
    price,
    compareAtPrice,
  },
  vendor,
  id,
  section_id,
  tags,
}) => featuredImage ?`
    <li class="grid__item scroll-trigger animate--slide-in scroll-trigger--cancel" data-cascade="" style="--animation-order: 8;">
      <div class="pd-product-card-wrapper card-wrapper product-card-wrapper">
            <div class="
              pd-product-card card card--standard page--collection
              card--media
              " style="--ratio-percent: 100%;">
              <div class="card__inner pd-product-card__inner  gradient ratio" style="--ratio-percent: 100%;">
                  <div class="card__media pd-product-card__media">
                    <a href="/products/${handle}" class="pd-product-card__media-link">
                        <div class="media media--transparent media--hover-effect">
                          <img loading="lazy" src="${featuredImage.url}" width="${featuredImage.width}" height="${featuredImage.height}" alt="${handle}">
                        </div>
                    </a>
                  </div>
                  <div class="card__badge card__badge--${id.replace('gid://shopify/Product/', '')}">
                    ${generatePrimaryBadgeHTML({ id, tags, availableForSale, selectedOrFirstAvailableVariant: { price, compareAtPrice } })}
                  </div>
                  <div class="pd-product-card__wishlist">
                    <button
                      aria-label="Add to Wishlist"
                      data-with-epi="true"
                      class="swym-button swym-add-to-wishlist-view-product product_${id.replace('gid://shopify/Product/', '')}"
                      data-swaction="addToWishlist"
                      data-product-id="${id.replace('gid://shopify/Product/', '')}"
                      data-variant-id="${variant_id.replace('gid://shopify/ProductVariant/', '')}"
                      data-product-url="https://www.goodgames.com.au/products/${handle}"
                    >
                    <span class="svg-wrapper">
                      <svg
                        class="icon icon--heart"
                        width="16"
                        height="16"
                        viewBox="0 0 16 16"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <rect width="16" height="16" fill="#E5F6FE"></rect>
                        <path d="M14 5.5C14 3.84315 12.6009 2.5 10.875 2.5C9.58459 2.5 8.47685 3.25085 8 4.32228C7.52315 3.25085 6.41541 2.5 5.125 2.5C3.39911 2.5 2 3.84315 2 5.5C2 10.3137 8 13.5 8 13.5C8 13.5 14 10.3137 14 5.5Z" stroke="#0c6bed" stroke-linecap="round" stroke-linejoin="round"></path>
                      </svg>
                    </span>
                    </button>
                  </div>
                  <div class="card__content">
                    <div class="card__information">
                        <h3 class="card__heading">
                          <a href="/products/${handle}" id="StandardCardNoMediaLink-${section_id}-${id}" class="full-unstyled-link pd-product-card__link" aria-labelledby="StandardCardNoMediaLink-${section_id}-${id} NoMediaStandardBadge-${section_id}-${id}">
                          ${title}
                          </a>
                        </h3>
                    </div>
                  </div>
              </div>
              <div class="pd-product-card__content">
                  <div class="pd-product-card__information">
                    <h4 class="pd-product-card__vendor">${vendor}</h4>
                    <h3 class="card__heading pd-product-card__heading" id="title-${section_id}-${id}" >
                        <a href="/products/${handle}" id="CardLink-${section_id}-${id}" class="full-unstyled-link pd-product-card__link" aria-labelledby="CardLink-${section_id}-${id} Badge-${section_id}-${id}">
                        ${title}
                        </a>
                    </h3>
                    <div class="card-information">
                        <div class="
                          price  price--on-sale">
                          <div class="price__container">
                              <div class="price__regular"><span class="visually-hidden visually-hidden--inline">Regular price</span>
                                <span class="price-item price-item--regular">
                                ${new Intl.NumberFormat('en-US', {
                                  style: 'currency',
                                  currency: 'USD'
                                }).format(price.amount)}
                                </span>
                              </div>
                              <div class="price__sale">
                                <span class="visually-hidden visually-hidden--inline">Regular price</span>
                                <span>
                                ${
                                  compareAtPrice && compareAtPrice.amount
                                    ? `
                                <s class="price-item price-item--regular">
                                ${new Intl.NumberFormat('en-US', {
                                  style: 'currency',
                                  currency: 'USD'
                                }).format(compareAtPrice.amount)}
                                </s>`
                                    : ""
                                }
                                </span><span class="visually-hidden visually-hidden--inline">Sale price</span>
                                <span class="price-item price-item--sale price-item--last">
                                 ${new Intl.NumberFormat('en-US', {
                                  style: 'currency',
                                  currency: 'USD'
                                }).format(price.amount)}
                                </span>
                              </div>
                              <small class="unit-price caption hidden">
                              <span class="visually-hidden">Unit price</span>
                              <span class="price-item price-item--last">
                              <span></span>
                              <span aria-hidden="true">/</span>
                              <span class="visually-hidden">&nbsp;per&nbsp;</span>
                              <span>
                              </span>
                              </span>
                              </small>
                          </div>
                        </div>
                        <div class="card__secondary-badge card__secondary-badge--${id.replace('gid://shopify/Product/', '')}">
                          ${generateSecondaryBadgeHTML({ id, tags })}
                        </div>
                    </div>
                  </div>
                  <div class="quick-add pd-quick-add no-js-hidden">
                    <product-form data-section-id="${section_id}">
                        <form
                          method="post"
                          action="/cart/add"
                          id="quick-add-${section_id}${id}"
                          accept-charset="UTF-8"
                          class="form"
                          enctype="multipart/form-data"
                          novalidate="novalidate"
                          data-type="add-to-cart-form"
                        >
                          <input type="hidden" name="form_type" value="product">
                          <input type="hidden" name="utf8" value="✓">
                          <input type="hidden" name="id" value="${variant_id.replace('gid://shopify/ProductVariant/', '')}" class="product-variant-id">
                          <button
                            id="quick-add-${section_id}${id}-submit"
                            type="submit"
                            name="add"
                            class="quick-add__submit pd-link pd-link--icon"
                            aria-haspopup="dialog"
                            aria-labelledby="quick-add-${section_id}${id}-submit title-${section_id}-${id}"
                            aria-live="polite"
                            data-sold-out-message="${!availableForSale}"
                            ${!availableForSale ? 'disabled' : ''}
                          >
                              <span class="pd-link__icon">
                                <svg class="icon icon--plus" width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <path d="M6 2.25V9.75M9.75 6L2.25 6" stroke="#0c6bed" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"></path>
                                </svg>
                              </span>
                              ${(() => {
                                const isPreorder = availableForSale && tags.includes('PREORDER');
                                const isBackorder = availableForSale && tags.includes('BACKORDER');
                                const isComingSoon = !availableForSale && tags.includes('PREORDER');
                                
                                if (isPreorder) return '<span class="pd-link__text">PREORDER</span>';
                                if (isBackorder) return '<span class="pd-link__text">Backorder</span>';
                                if (availableForSale) return '<span class="pd-link__text">Add to cart</span>';
                                if (isComingSoon) return '<span class="sold-out-message">Coming soon</span>';
                                return '<span class="sold-out-message">Sold out</span>';
                              })()}
                              <div class="loading__spinner hidden">
                                <svg xmlns="http://www.w3.org/2000/svg" class="spinner" viewBox="0 0 66 66">
                                    <circle stroke-width="6" cx="33" cy="33" r="30" fill="none" class="path"></circle>
                                </svg>
                              </div>
                          </button>
                          <input type="hidden" name="product-id" value="${id}"><input type="hidden" name="section-id" value="${section_id}">
                        </form>
                    </product-form>
                  </div>
              </div>
            </div>
        </div>
      </li>
`: '';

const SORT_BY_MAP = {
  'title-ascending': 'TITLE',
  'title-descending': 'TITLE',
  'best-selling': 'BEST_SELLING',
  'price-ascending': 'PRICE',
  'price-descending': 'PRICE',
  'created-descending': 'CREATED_AT',
  'created-ascending': 'CREATED_AT',
  'manual': '',
}

async function fetchGraphQL(query) {
  return fetch(
    `${location.origin}/api/2025-07/graphql.json`,
    {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        "X-Shopify-Access-Token": "d76f7ed840bf170e48691d62c7c13160",
      },
      body: JSON.stringify({
        query,
      }),
    }
  ).then((res) => res.json()).catch((err) => console.log(err));
}

class FacetFiltersForm extends HTMLElement {
  constructor() {
    super();
    this.onActiveFilterClick = this.onActiveFilterClick.bind(this);

    this.debouncedOnSubmit = debounce((event) => {
      this.onSubmitHandler(event);
    }, 800);

    const facetForm = this.querySelector('form');
    facetForm.addEventListener('input', (event) => {
      FacetFiltersForm.showLoadingState();
      this.debouncedOnSubmit(event);
    });

    const facetWrapper = this.querySelector('#FacetsWrapperDesktop');
    if (facetWrapper) facetWrapper.addEventListener('keyup', onKeyUpEscape);

    FacetFiltersForm.updateMobileFilterCount();
  }

  static setListeners() {
    const onHistoryChange = (event) => {
      const searchParams = event.state ? event.state.searchParams : FacetFiltersForm.searchParamsInitial;
      if (searchParams === FacetFiltersForm.searchParamsPrev) return;
      FacetFiltersForm.renderPage(searchParams, null, false);
    };
    window.addEventListener('popstate', onHistoryChange);
  }

  static toggleActiveFacets(disable = true) {
    document.querySelectorAll('.js-facet-remove').forEach((element) => {
      element.classList.toggle('disabled', disable);
    });
  }

  static renderLoadMoreButton(html) {
    const parsedHTML = new DOMParser().parseFromString(html, 'text/html');
    const ELM_productGrid = parsedHTML.querySelector('#product-grid');
    const ELM_loadMore = document.querySelector('.js-load-more');
    const totalPage = ELM_productGrid?.dataset.totalPage;
    const currentPage = ELM_productGrid?.dataset.currentPage;
    const totalPageInt = parseInt(totalPage);
    const currentPageInt = parseInt(currentPage);
    if (totalPageInt > currentPageInt) {
      ELM_loadMore?.classList.remove('hide');
    } else {
      ELM_loadMore?.classList.add('hide');
    }
  }

  // custom render product grid
  static prepareProductsHTML(products, hasPreviousPage) {
    const productGrid = document.getElementById("product-grid");

    if (products.length > 0) {
      const productsHTML = products.map((product) => PRODUCT_CARD_HTML(product));

      if (hasPreviousPage) {
        productGrid.innerHTML = productGrid.innerHTML + productsHTML.join("");
      } else {
        productGrid.innerHTML = productsHTML.join("");
      } 
    } else {
      productGrid.innerHTML = '<div class="pd-collection__empty">Sorry, there are no products in this collection</div>';
    }
  }

  static renderNextPageButton(searchParams, pageInfo) {
    if (searchParams.includes('filter.p.t.category=')) {
      return;
    }

    const loadMoreBtn = document.querySelector(".load-more__btn");
    const searchLoadMoreBtn = document.querySelector(".collection-search-load-more");
    const loadMoreSpinner = document.querySelector(".load-more-spinner");

    if (!pageInfo.hasNextPage) {
      if (searchLoadMoreBtn) {
        searchLoadMoreBtn.classList.add("hidden");
      }

      if (loadMoreBtn) {
        loadMoreBtn.classList.add("hidden");
      }

      if (loadMoreSpinner) {
        loadMoreSpinner.classList.add("hidden");
      }

      return;
    }

    const button = document.createElement("button");

    button.classList.add("pd-button", "pd-button--primary", 'collection-search-load-more');
    button.innerHTML = "Load more";
    button.innerHTML += `
      ${loadMoreSpinner ? `<div class="loading__spinner hidden">
        <svg xmlns="http://www.w3.org/2000/svg" class="spinner" width="24" height="24" viewBox="0 0 66 66">
          <circle stroke-width="6" cx="33" cy="33" r="30" fill="none" class="path"></circle>
        </svg>
      </div>` : ''}
    `;

    button.addEventListener("click", () => {
      button.classList.add("loading");
      FacetFiltersForm.renderPage(searchParams)
    });

    if (loadMoreBtn) {
      loadMoreBtn.replaceWith(button);
    }
  }

  static separateTagsByType(tags) {
    const maxPlayers = tags.filter((tag) => tag.includes('Maximum+Players'));
    const theme = tags.filter((tag) => tag.includes('Theme'));
    const mechanic = tags.filter((tag) => tag.includes('Mechanic'));

    return {
      maxPlayers,
      theme,
      mechanic,
    };
  }

  static buildTagQuery(tags) {
    const { maxPlayers, theme, mechanic } = this.separateTagsByType(tags);

    const maxPlayersQuery = maxPlayers.length > 0 ? `(tag:${maxPlayers.join(' OR tag:')})` : '';
    const themeQuery = theme.length > 0 ? `(tag:${theme.join(' OR tag:')})` : '';
    const mechanicQuery = mechanic.length > 0 ? `(tag:${mechanic.join(' OR tag:')})` : '';

    return `${maxPlayersQuery} ${themeQuery} ${mechanicQuery}`;
  }

  static buildSearchQuery(searchParams, endCursor, ppp = 250) {
    const searches = new URLSearchParams(searchParams);
    const title = searches.get("q");
    const sortBy = searches.get("sort_by");
    const sortByValue = SORT_BY_MAP[sortBy] || '';
    const reverse = sortBy && sortBy.includes('-descending');

    const tags = searches.getAll("filter.p.tag");
    const tagQuery = this.buildTagQuery(tags);

    const categories = searches.getAll("filter.p.t.category");
    
    const brands = searches.getAll("filter.p.vendor");
    let brandFilter = '';

    if (brands.length > 0) {
      brandFilter = ` AND vendor:${brands.join(' OR vendor:')}`;
    }

    const collectionId = searches.get("collection_id");
    const ELM_productGrid = document.querySelector("#product-grid");
    let productsPerPage = categories.length > 0 ? 250 : ELM_productGrid.dataset.productsPerPage || 16;

    return `first: ${ppp || productsPerPage},
            query: "title:${title}* AND collection_id:${collectionId}${brandFilter}${tagQuery}",
            reverse: ${reverse}
            ${sortByValue ? `, sortKey: ${sortByValue}` : ''}
            ${endCursor ? `, after: "${endCursor}"` : ""}`;
  }

  static async searchProductInCollection(searchParams, endCursor) {
    try {
      const productCriteria = FacetFiltersForm.buildSearchQuery(searchParams, endCursor);
      
      const query = `
        query GetProducts {
          products(${productCriteria}) {
            nodes {
              id
              title
              handle
              availableForSale
              vendor
              tags
              category {
                id
                name
              }
              featuredImage {
                url
                width
                height
              }
              variants (first: 250) {
                nodes {
                  availableForSale
                }
              }
              selectedOrFirstAvailableVariant {
                id
                compareAtPrice {
                  amount
                }
                price {
                  amount
                }
              }
            }
            
            pageInfo {
              hasNextPage
              hasPreviousPage
              endCursor
            }
          }
        }`;

      const responseBody = await fetchGraphQL(query);

      const products = responseBody?.data?.products?.nodes || [];
      const pageInfo = responseBody?.data?.products?.pageInfo || {};

      if (pageInfo.hasNextPage) {
        FacetFiltersForm.endCursor = pageInfo.endCursor;
      }

      let filteredProducts = products;

      const searches = new URLSearchParams(searchParams);
      const categories = searches.getAll("filter.p.t.category");
      const availabilities = searches.getAll("filter.v.availability");

      if (categories.length > 0) {
        filteredProducts = products.filter((product) => {
          if (product.category && product.category.id) {
            const categoryId = product.category.id;
            return categories.some((category) => categoryId.includes(category));
          }
        });
      }

      if (availabilities.length > 0 && availabilities.length === 1) {
        filteredProducts = filteredProducts.filter((product) => {
          const availableVariant = product.variants.nodes.some(v => v.availableForSale === !!(+availabilities[0]));
          const availableProduct = product.availableForSale === !!(+availabilities[0]);

          return availableVariant || availableProduct;
        })
      }

      return {
        products: filteredProducts,
        pageInfo
      };
    } catch (err) {
      console.log("err ---", err);
    }
  }

  static async fetchProductsFilters(searchParams) {
    try {
      const productCriteria = FacetFiltersForm.buildSearchQuery(searchParams, null, 250);
      
      const query = `
        query GetProductFilters {
          products(${productCriteria}) {
            nodes {
              availableForSale
              vendor
              tags
              category {
                id
                name
              }
            }
          }
        }`;

      const responseBody = await fetchGraphQL(query);
      const products = responseBody?.data?.products?.nodes || [];
 
      return products;
    } catch (err) {
      console.log("err ---", err);
    }
  }
  
  static async renderSearchFilters(searchParams) {
    const products = await this.fetchProductsFilters(searchParams);
    const filterStructure = this.buildFilterStructure(products, searchParams);

    this.renderDynamicFilters(filterStructure);
    this.renderDynamicFiltersMobile(filterStructure);
  }

  static buildFilterStructure(products, searchParams) {
    const searches = new URLSearchParams(searchParams);
    const activeFilters = {
      tags: searches.getAll("filter.p.tag"),
      vendors: searches.getAll("filter.p.vendor"),
      availability: searches.getAll("filter.v.availability"),
      categories: searches.getAll("filter.p.t.category")
    };

    const filterStructure = {};
    
    // Build vendor filter
    const vendors = {};
    products.forEach(product => {
      if (product.vendor) {
        vendors[product.vendor] = (vendors[product.vendor] || 0) + 1;
      }
    });
    
    if (Object.keys(vendors).length > 0) {
      filterStructure.vendor = {
        label: 'Brand',
        param_name: 'filter.p.vendor',
        values: Object.keys(vendors).sort().map(vendor => ({
          label: vendor,
          value: vendor,
          count: vendors[vendor],
          active: activeFilters.vendors.includes(vendor)
        }))
      };
    }

    // Build availability filter
    const availabilities = {};
    products.forEach(product => {
      const available = Number(product.availableForSale).toString();
      availabilities[available] = (availabilities[available] || 0) + 1;
    });
    
    if (Object.keys(availabilities).length > 1) {
      filterStructure.availability = {
        label: 'Availability',
        param_name: 'filter.v.availability',
        values: [
          { label: 'In stock', value: '1', count: availabilities['1'] || 0, active: activeFilters.availability.includes('1') },
          { label: 'Out of stock', value: '0', count: availabilities['0'] || 0, active: activeFilters.availability.includes('0') }
        ].filter(item => item.count > 0)
      };
    }

    // Build categories filter
    const categories = [];
    products.forEach(product => {
      
      if (product.category && product.category.name) {
        const idTruncated = product.category.id.replace('gid://shopify/TaxonomyCategory/', '');

        if (!categories.find(c => c.value === idTruncated)) {
          categories.push({
            label: product.category.name,
            value: idTruncated,
          });
        }
      }
    });
    if (categories.length > 0) {
      filterStructure.category = {
        label: 'Category',
        param_name: 'filter.p.t.category',
        values: categories.sort((a, b) => a.label.localeCompare(b.label)).map(category => ({
          label: category.label,
          value: category.value,
          count: categories.filter(c => c.value === category.value).length,
          active: activeFilters.categories.includes(category.value)
        }))
      };
    }

    // Build tags filter (Theme, Mechanic, Maximum Players)
    const tagCategories = {
      'Theme': {},
      'Mechanic': {},
      'Maximum Players': {}
    };

    products.forEach(product => {
      product.tags.forEach(tag => {
        if (tag.includes('Theme_')) {
          const value = tag.replace('Theme_', '');
          tagCategories['Theme'][tag] = {
            label: value,
            value: tag,
            count: (tagCategories['Theme'][tag]?.count || 0) + 1
          };
        } else if (tag.includes('Mechanic_')) {
          const value = tag.replace('Mechanic_', '');
          tagCategories['Mechanic'][tag] = {
            label: value,
            value: tag,
            count: (tagCategories['Mechanic'][tag]?.count || 0) + 1
          };
        } else if (tag.includes('Maximum Players_')) {
          const value = tag.replace('Maximum Players_', '');
          tagCategories['Maximum Players'][tag] = {
            label: value,
            value: tag,
            count: (tagCategories['Maximum Players'][tag]?.count || 0) + 1
          };
        }
      });
    });

    // Convert tag categories to filter structure
    Object.keys(tagCategories).forEach(category => {
      const tags = tagCategories[category];
      if (Object.keys(tags).length > 0) {
        const values = Object.values(tags).sort((a, b) => {
          // Sort Maximum Players numerically, others alphabetically
          if (category === 'Maximum Players') {
            return parseInt(a.label) - parseInt(b.label);
          }
          return a.label.localeCompare(b.label);
        }).map(tag => ({
          ...tag,
          active: activeFilters.tags.includes(tag.value)
        }));
        
        filterStructure[category.toLowerCase().replace(' ', '_')] = {
          label: category,
          param_name: 'filter.p.tag',
          values: values
        };
      }
    });

    return filterStructure;
  }

  static renderDynamicFilters(filterStructure) {
    let facetsDesktop = document.getElementById('FacetsWrapperDesktop');
    if (!facetsDesktop) return;

    const targetFilters = ['vendor', 'availability', 'theme', 'mechanic', 'maximum_players', 'category'];
    
    targetFilters.forEach(filterKey => {
      const filter = filterStructure[filterKey];
      if (!filter) return;
      
      facetsDesktop = document.getElementById('FacetsWrapperDesktop');
      let filterElement = document.querySelector(`[data-filter-label="${filter.label.toLowerCase().replace(' ', '-')}"]`);
      
      if (filterElement) {
        this.updateFilterElement(filterElement, filter);
      } else {
        const newFilterElement = this.createFilterElement(filter, filterKey);
        if (newFilterElement) {
          const clearButton = facetsDesktop.parentElement.querySelector('facet-remove');
          if (clearButton) {
            clearButton.parentElement.insertBefore(newFilterElement, clearButton);
          } else {
            facetsDesktop.appendChild(newFilterElement);
          }
        }
      }
    });
  }

  static updateFilterElement(filterElement, filter) {
    const filterList = filterElement.querySelector('.facets__list--vertical, .facets__list');
    if (!filterList) return;

    // Clear and rebuild the filter list
    filterList.innerHTML = '';

    filter.values.forEach((value, index) => {
      const listItem = this.createFilterItem(value, filter.param_name, index + 1);
      filterList.appendChild(listItem);
    });

    // Update the filter summary count
    const summary = filterElement.querySelector('.facets__summary .facets__selected');
    if (summary) {
      const activeCount = filter.values.filter(v => v.active).length;
      summary.textContent = activeCount > 0 ? `(${activeCount})` : '';
      summary.classList.toggle('hidden', activeCount === 0);
    }
  }

  static createFilterElement(filter, filterKey) {
    const sectionId = document.querySelector('[data-section-id]')?.dataset.sectionId || 'main';
    const filterIndex = document.querySelectorAll('.js-filter').length + 1;

    const filterHTML = `
      <details
        id="Details-${filter.param_name.replace(/\./g, '-')}-${filterKey}-${sectionId}"
        class="facets__disclosure-vertical js-filter"
        data-index="${filterIndex}"
        data-filter-label="${filter.label.toLowerCase().replace(' ', '-')}"
      >
        <summary
          class="facets__summary focus-offset"
          aria-label="${filter.label} (0 selected)"
        >
          <span class="facets__summary-label">
            ${filter.label}
          </span>
          <div class="facets__icons">
            <svg class="icon icon--blue-plus icon--plus" xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
              <path d="M8 3V13M13 8L3 8" stroke="#0c6bed" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"></path>
            </svg>
            <svg class="icon icon--blue-minus icon--minus" xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
              <path d="M3.33325 8H12.6666" stroke="#0c6bed" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"></path>
            </svg>
          </div>
        </summary>
        <div
          id="Facet-${filterIndex}-${sectionId}"
          class="parent-display facets__display-vertical"
        >
          <fieldset class="facets-wrap parent-wrap facets-wrap-vertical">
            <legend class="visually-hidden">${filter.label}</legend>
            <ul
              class="facets-layout facets-layout-list facets-layout-list--text facets__list--vertical list-unstyled"
              role="list"
            >
              ${filter.values.map((value, index) => FacetFiltersForm.createFilterItemHTML(value, filter.param_name, index + 1)).join('')}
            </ul>
          </fieldset>
        </div>
      </details>
    `;

    const tempDiv = document.createElement('div');
    tempDiv.innerHTML = filterHTML;
    return tempDiv.firstElementChild;
  }

  static createFilterItem(value, paramName, index) {
    const li = document.createElement('li');
    li.className = 'list-menu__item facets__item';
    li.setAttribute('data-filter-value', value.value);
    li.innerHTML = this.createFilterItemHTML(value, paramName, index);
    return li;
  }

  static handleize(value) {
    return value.replace(/\s+/g, '-').toLowerCase();
  }

  static createFilterItemHTML(value, paramName, index) {
    const inputId = `Filter-${paramName.replace(/\./g, '-')}-${index}-${this.handleize(value.label)}`;
    const isDisabled = value.count === 0 && !value.active;
    const labelClass = `facets__label facet-checkbox${isDisabled ? ' disabled' : ''}${value.active ? ' active' : ''}`;

    return `
    <li class="list-menu__item facets__item">
      <label for="${inputId}" class="${labelClass}">
        <div class="checkbox-wrapper">
          <input
            type="checkbox"
            name="${paramName}"
            value="${value.value}"
            id="${inputId}"
            ${value.active ? 'checked' : ''}
            ${isDisabled ? 'disabled' : ''}
          >
          <svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg" class="icon icon--checkbox" style="border: 1px solid #1E2C48;">
            <rect width="14" height="14" fill="#E5F6FE"/>
          </svg>
          <svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg" class="icon icon--checkbox-checked">
            <rect width="14" height="14" fill="#1E2C48"/>
            <path fill-rule="evenodd" clip-rule="evenodd" d="M11.8536 4.35356L5.50004 10.7071L2.64648 7.85356L3.35359 7.14645L5.50004 9.2929L11.1465 3.64645L11.8536 4.35356Z" fill="white"/>
          </svg>
        </div>
        <span class="facet-checkbox__text" aria-hidden="true">
          <span class="facet-checkbox__text-label">${value.label}</span>
        </span>
        <span class="visually-hidden">
          ${value.label} (${value.count === 1 ? '1 product' : `${value.count} products`})
        </span>
      </label>
    </li>
    `;
  }

  static renderDynamicFiltersMobile(filterStructure) {
    const facetsMobile = document.getElementById('FacetsWrapperMobile');
    if (!facetsMobile) return;

    // Handle mobile filters similar to desktop, but with mobile-specific classes
    const targetFilters = ['vendor', 'availability', 'theme', 'mechanic', 'maximum_players', 'category'];
    targetFilters.forEach(filterKey => {
      const filter = filterStructure[filterKey];
      if (!filter) return;

      let filterElement = facetsMobile.querySelector(`[data-mobile-filter="${filter.label.toLowerCase().replace(' ', '-')}"]`);
      
      if (filterElement) {
        this.updateFilterElementMobile(filterElement, filter);
      } else {
        const newFilterElement = this.createFilterElementMobile(filter, filterKey);
        if (newFilterElement) {
          // Insert before the footer
          const footer = facetsMobile.querySelector('.mobile-facets__footer');

          if (footer) {
            footer.parentElement.insertBefore(newFilterElement, footer);
          } else {
            facetsMobile.appendChild(newFilterElement);
          }
        }
      }
    });
  }

  static updateFilterElementMobile(filterElement, filter) {
    const filterList = filterElement.querySelector('.mobile-facets__list');
    if (!filterList) return;

    filterList.innerHTML = '';
    
    filter.values.forEach((value, index) => {
      const listItem = this.createFilterItemMobile(value, filter.param_name, index + 1);
      filterList.appendChild(listItem);
    });
  }

  static createFilterElementMobile(filter, filterKey) {
    const sectionId = document.querySelector('[data-section-id]')?.dataset.sectionId || 'main';
    const filterIndex = Object.keys(document.querySelectorAll('.mobile-facets__details')).length + 1;

    const filterHTML = `
      <details
        id="Details-Mobile-${filter.param_name.replace(/\./g, '-')}-${filterKey}-${sectionId}"
        class="mobile-facets__details js-filter"
        data-index="mobile-${filterIndex}"
        data-mobile-filter="${filter.label.toLowerCase().replace(' ', '-')}"
      >
        <summary class="mobile-facets__summary">
          <span>${filter.label}</span>
          <div class="mobile-facets__icons" bis_skin_checked="1">
            <svg class="icon icon--blue-plus icon--plus" xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
              <path d="M8 3V13M13 8L3 8" stroke="#0c6bed" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"></path>
            </svg>
            <svg class="icon icon--blue-minus icon--minus" xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
              <path d="M3.33325 8H12.6666" stroke="#0c6bed" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"></path>
            </svg>
          </div>
        </summary>
        <div id="FacetMobile-${filterIndex}-${sectionId}">
          <ul class="mobile-facets__list" role="list">
            ${filter.values.map((value, index) => FacetFiltersForm.createFilterItemMobileHTML(value, filter.param_name, index + 1)).join('')}
          </ul>
        </div>
      </details>
    `;

    const tempDiv = document.createElement('div');
    tempDiv.innerHTML = filterHTML;
    return tempDiv.firstElementChild;
  }

  static createFilterItemMobile(value, paramName, index) {
    const li = document.createElement('li');
    li.className = 'mobile-facets__item list-menu__item';
    li.innerHTML = this.createFilterItemMobileHTML(value, paramName, index);
    return li;
  }

  static createFilterItemMobileHTML(value, paramName, index) {
    const inputId = `Filter-${paramName.replace(/\./g, '-')}-mobile-${index}-${this.handleize(value.label)}`;
    const isDisabled = value.count === 0 && !value.active;
    const labelClass = `facets__label mobile-facets__label${isDisabled ? ' disabled' : ''}${value.active ? ' active' : ''}`;

    return `
    <li class="mobile-facets__item list-menu__item">
      <label for="${inputId}" class="${labelClass}">
        <div class="checkbox-wrapper">
          <input
            class="mobile-facets__checkbox"
            type="checkbox"
            name="${paramName}"
            value="${value.value}"
            id="${inputId}"
            ${value.active ? 'checked' : ''}
            ${isDisabled ? 'disabled' : ''}
          >
          <svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg" class="icon icon--checkbox" style="border: 1px solid #1E2C48;">
            <rect width="14" height="14" fill="#fff"/>
          </svg>
          <svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg" class="icon icon--checkbox-checked">
            <rect width="14" height="14" fill="#1E2C48"/>
            <path fill-rule="evenodd" clip-rule="evenodd" d="M11.8536 4.35356L5.50004 10.7071L2.64648 7.85356L3.35359 7.14645L5.50004 9.2929L11.1465 3.64645L11.8536 4.35356Z" fill="white"/>
          </svg>
        </div>
        <span class="facet-checkbox__text" aria-hidden="true">
          <span class="facet-checkbox__text-label">${value.label}</span>
        </span>
        <span class="visually-hidden">
          ${value.label} (${value.count === 1 ? '1 product' : `${value.count} products`})
        </span>
      </label>
    </li>
    `;
  }

  static updateFacetsDesktop(filters) {
    const facetsDesktop = document.getElementById('FacetsWrapperDesktop');
    const facetsDesktopItems = facetsDesktop.querySelectorAll('.facets__item');

    facetsDesktopItems.forEach(item => {
      const filterValue = item.dataset.filterValue;

      if (filterValue && !filters.includes(filterValue)) {
        item.classList.add('hidden');
      } else {
        item.classList.remove('hidden');
      }
    });

    const details = document.querySelectorAll('.facets__disclosure-vertical');
    details.forEach(detail => {
      const items = detail.querySelectorAll('.facets__item') || [];

      if (items.length > 0 && Array.from(items).every(item => item.classList.contains('hidden'))) {
        detail.classList.add('hidden');
      } else {
        detail.classList.remove('hidden');
      }
    })
  }

  static toggleGridLoading() {
    document
      .getElementById("ProductGridContainer")
      .querySelector(".collection")
      .classList.toggle("loading");
  }

  static showLoadingState() {
    const loadingSpinners = document.querySelectorAll(
      ".facets-container .loading__spinner, facet-filters-form .loading__spinner"
    );
    loadingSpinners.forEach((spinner) => spinner.classList.remove("hidden"));

    const productGrid = document.getElementById("product-grid");
    if (productGrid) {
      productGrid.classList.add("loading");
    }

    const countContainer = document.getElementById("ProductCount");
    const countContainerDesktop = document.getElementById("ProductCountDesktop");
    
    if (countContainer) {
      countContainer.classList.add("loading");
    }
    if (countContainerDesktop) {
      countContainerDesktop.classList.add("loading");
    }
  }
  static updateClearAll(searchParams) {
    const searches = new URLSearchParams(searchParams || location.search);

    const q = searches.get('q');
    const collection_id = searches.get('collection_id');
    const sort_by = searches.get('sort_by');
    const hasFilters = Array.from(searches.keys()).some((key) => key.startsWith('filter.'));
    
    const facetRemoves = document.querySelectorAll('facet-remove') || [];

    facetRemoves.forEach(facetRemove => {
      const facetRemoveLink = facetRemove.querySelector('a');

      if (facetRemoveLink) {
        facetRemoveLink.href = location.pathname + '?' + (q ? `&q=${q}` : '') + (collection_id ? `&collection_id=${collection_id}` : '') + (sort_by ? `&sort_by=${sort_by}` : '');
      }

      if (hasFilters) {
        facetRemove.classList.remove('hidden');
      } else {
        facetRemove.classList.add('hidden');
      }
    });
  }

  static updateMobileFilterCount(searchParams) {
    const searches = new URLSearchParams(searchParams || location.search);
    let count = 0;

    searches.entries().forEach(i => {
      if (i && i[0].includes('filter')) count++      
    })

    const mobileFilterCount = document.getElementById('mobile-filter-count');
    if (mobileFilterCount) {
      if ( count > 0) {
        mobileFilterCount.innerHTML = `(${count})`;
      } else {
        mobileFilterCount.innerHTML = '';
      }
    }
  }
  

  static hideLoadingState() {
    const loadingSpinners = document.querySelectorAll(
      '.facets-container .loading__spinner, facet-filters-form .loading__spinner'
    );
    loadingSpinners.forEach((spinner) => spinner.classList.add('hidden'));

    const productGrid = document.getElementById("product-grid");
    if (productGrid) {
      productGrid.classList.remove("loading");
    }

    const countContainer = document.getElementById("ProductCount");
    const countContainerDesktop = document.getElementById("ProductCountDesktop");
    
    if (countContainer) {
      countContainer.classList.remove("loading");
    }
    if (countContainerDesktop) {
      countContainerDesktop.classList.remove("loading");
    }
  }

  static async renderPage(searchParams, event, updateURLHash = true) {
    const isCollectionSearch = searchParams.includes("q=") && location.pathname.includes("/collections");

    FacetFiltersForm.searchParamsPrev = searchParams;
    FacetFiltersForm.showLoadingState();

    if (isCollectionSearch) {
      const { products, pageInfo } = await FacetFiltersForm.searchProductInCollection(searchParams, FacetFiltersForm.endCursor);

      FacetFiltersForm.prepareProductsHTML(products, pageInfo.hasPreviousPage);
      FacetFiltersForm.renderNextPageButton(searchParams, pageInfo);
      FacetFiltersForm.renderSearchFilters(searchParams);
      FacetFiltersForm.hideLoadingState();

      // since Storefront API doesn't return product count, temporarily hide all product count
      FacetFiltersForm.hideAllProductCount();
    } else {
      const sections = FacetFiltersForm.getSections();

      sections.forEach((section) => {
        const url = `${window.location.pathname}?section_id=${section.section}&${searchParams}`;
        const filterDataUrl = (element) => element.url === url;

        FacetFiltersForm.filterData.some(filterDataUrl)
          ? FacetFiltersForm.renderSectionFromCache(filterDataUrl, event)
          : FacetFiltersForm.renderSectionFromFetch(url, event);
      });
    }

    if (updateURLHash) FacetFiltersForm.updateURLHash(searchParams);

    // custom behaviors
    FacetFiltersForm.updateMobileFilterCount(searchParams)
    FacetFiltersForm.updateClearAll(searchParams)

    setTimeout(() => {
      window._swat.initializeActionButtons('#ProductGridContainer');
    }, 2000);
  }

  static renderSectionFromFetch(url, event) {
    fetch(url)
      .then((response) => response.text())
      .then((responseText) => {
        const html = responseText;
        FacetFiltersForm.filterData = [...FacetFiltersForm.filterData, { html, url }];
        FacetFiltersForm.renderFilters(html, event);
        FacetFiltersForm.renderProductGridContainer(html);
        FacetFiltersForm.renderProductCount(html);
        FacetFiltersForm.renderLoadMoreButton(html);
        if (typeof initializeScrollAnimationTrigger === 'function') initializeScrollAnimationTrigger(html);
        if (typeof window.initInfiniteScroll === 'function') window.initInfiniteScroll();
      });
  }

  static renderSectionFromCache(filterDataUrl, event) {
    const html = FacetFiltersForm.filterData.find(filterDataUrl).html;
    FacetFiltersForm.renderFilters(html, event);
    FacetFiltersForm.renderProductGridContainer(html);
    FacetFiltersForm.renderProductCount(html);
    FacetFiltersForm.renderLoadMoreButton(html);
    if (typeof initializeScrollAnimationTrigger === 'function') initializeScrollAnimationTrigger(html);
    if (typeof window.initInfiniteScroll === 'function') window.initInfiniteScroll();
  }

  static renderProductGridContainer(html) {
    document.getElementById('ProductGridContainer').innerHTML = new DOMParser()
      .parseFromString(html, 'text/html')
      .getElementById('ProductGridContainer')?.innerHTML;

    document
      .getElementById('ProductGridContainer')
      .querySelectorAll('.scroll-trigger')
      .forEach((element) => {
        element.classList.add('scroll-trigger--cancel');
      });
  }

  static hideAllProductCount() {
    const container = document.getElementById("ProductCount");
    const containerDesktop = document.getElementById("ProductCountDesktop");
    const mobileCount = document.querySelector(".mobile-facets__count");

    if (container) {
      container.classList.add("hidden");
    }

    if (containerDesktop) {
      containerDesktop.classList.add("hidden");
    }

    if (mobileCount) {
      mobileCount.classList.add("hidden");
    }
  }

  static renderProductCount(html) {
    const count = new DOMParser().parseFromString(html, 'text/html').getElementById('ProductCount')?.innerHTML;
    const container = document.getElementById('ProductCount');
    const containerDesktop = document.getElementById('ProductCountDesktop');
    const mobileCount = document.querySelector('.mobile-facets__count');

    let formattedCount = count;

    if (count?.includes('of')) {
      const countNumber = count.split('of')[0];
      formattedCount = `${countNumber} product${+countNumber > 1 ? 's' : ''}`;
    }
    
    container.innerHTML = formattedCount;
    if (mobileCount) {
      mobileCount.innerHTML = formattedCount; 
    }

    container.classList.remove('loading');
    if (containerDesktop) {
      containerDesktop.innerHTML = formattedCount;
      containerDesktop.classList.remove('loading');
    }
    
    // Hide loading state when product count is rendered
    FacetFiltersForm.hideLoadingState();
  }

  static renderFilters(html, event) {
    const parsedHTML = new DOMParser().parseFromString(html, 'text/html');
    const facetDetailsElementsFromFetch = parsedHTML.querySelectorAll(
      '#FacetFiltersForm .js-filter, #FacetFiltersFormMobile .js-filter, #FacetFiltersPillsForm .js-filter'
    );
    const facetDetailsElementsFromDom = document.querySelectorAll(
      '#FacetFiltersForm .js-filter, #FacetFiltersFormMobile .js-filter, #FacetFiltersPillsForm .js-filter'
    );

    // Remove facets that are no longer returned from the server
    Array.from(facetDetailsElementsFromDom).forEach((currentElement) => {
      if (!Array.from(facetDetailsElementsFromFetch).some(({ id }) => currentElement.id === id)) {
        currentElement.remove();
      }
    });

    const matchesId = (element) => {
      const jsFilter = event ? event.target.closest('.js-filter') : undefined;
      return jsFilter ? element.id === jsFilter.id : false;
    };

    const facetsToRender = Array.from(facetDetailsElementsFromFetch).filter((element) => !matchesId(element));
    const countsToRender = Array.from(facetDetailsElementsFromFetch).find(matchesId);

    facetsToRender.forEach((elementToRender, index) => {
      const currentElement = document.getElementById(elementToRender.id);
      // Element already rendered in the DOM so just update the innerHTML
      if (currentElement) {
        document.getElementById(elementToRender.id).innerHTML = elementToRender.innerHTML;
      } else {
        if (index > 0) {
          const { className: previousElementClassName, id: previousElementId } = facetsToRender[index - 1];
          // Same facet type (eg horizontal/vertical or drawer/mobile)
          if (elementToRender.className === previousElementClassName) {
            document.getElementById(previousElementId).after(elementToRender);
            return;
          }
        }

        if (elementToRender.parentElement) {
          document.querySelector(`#${elementToRender.parentElement.id} .js-filter`).before(elementToRender);
        }
      }
    });

    FacetFiltersForm.renderActiveFacets(parsedHTML);
    FacetFiltersForm.renderAdditionalElements(parsedHTML);

    if (countsToRender) {
      const closestJSFilterID = event.target.closest('.js-filter').id;

      if (closestJSFilterID) {
        FacetFiltersForm.renderCounts(countsToRender, event.target.closest('.js-filter'));
        FacetFiltersForm.renderMobileCounts(countsToRender, document.getElementById(closestJSFilterID));

        const newFacetDetailsElement = document.getElementById(closestJSFilterID);
        const newElementSelector = newFacetDetailsElement.classList.contains('mobile-facets__details')
          ? `.mobile-facets__close-button`
          : `.facets__summary`;
        const newElementToActivate = newFacetDetailsElement.querySelector(newElementSelector);

        const isTextInput = event.target.getAttribute('type') === 'text';

        if (newElementToActivate && !isTextInput) newElementToActivate.focus();
      }
    }
  }

  static renderActiveFacets(html) {
    const activeFacetElementSelectors = ['.active-facets-mobile', '.active-facets-desktop'];

    activeFacetElementSelectors.forEach((selector) => {
      const activeFacetsElement = html.querySelector(selector);
      if (!activeFacetsElement) return;
      document.querySelector(selector).innerHTML = activeFacetsElement.innerHTML;
    });

    FacetFiltersForm.toggleActiveFacets(false);
  }

  static renderAdditionalElements(html) {
    const mobileElementSelectors = ['.mobile-facets__open', '.mobile-facets__count', '.sorting'];

    mobileElementSelectors.forEach((selector) => {
      if (!html.querySelector(selector)) return;
      document.querySelector(selector).innerHTML = html.querySelector(selector).innerHTML;
    });

    document.getElementById('FacetFiltersFormMobile')?.closest('menu-drawer').bindEvents();
  }

  static renderCounts(source, target) {
    const targetSummary = target.querySelector('.facets__summary');
    const sourceSummary = source.querySelector('.facets__summary');

    if (sourceSummary && targetSummary) {
      targetSummary.outerHTML = sourceSummary.outerHTML;
    }

    const targetHeaderElement = target.querySelector('.facets__header');
    const sourceHeaderElement = source.querySelector('.facets__header');

    if (sourceHeaderElement && targetHeaderElement) {
      targetHeaderElement.outerHTML = sourceHeaderElement.outerHTML;
    }

    const targetWrapElement = target.querySelector('.facets-wrap');
    const sourceWrapElement = source.querySelector('.facets-wrap');

    if (sourceWrapElement && targetWrapElement) {
      const isShowingMore = Boolean(target.querySelector('show-more-button .label-show-more.hidden'));
      if (isShowingMore) {
        sourceWrapElement
          .querySelectorAll('.facets__item.hidden')
          .forEach((hiddenItem) => hiddenItem.classList.replace('hidden', 'show-more-item'));
      }

      targetWrapElement.outerHTML = sourceWrapElement.outerHTML;
    }
  }

  static renderMobileCounts(source, target) {
    const targetFacetsList = target.querySelector('.mobile-facets__list');
    const sourceFacetsList = source.querySelector('.mobile-facets__list');

    if (sourceFacetsList && targetFacetsList) {
      targetFacetsList.outerHTML = sourceFacetsList.outerHTML;
    }
  }

  static updateURLHash(searchParams) {
    history.pushState({ searchParams }, '', `${window.location.pathname}${searchParams && '?'.concat(searchParams)}`);
  }

  static getSections() {
    return [
      {
        section: document.getElementById('product-grid').dataset.id,
      },
    ];
  }

  createSearchParams(form) {
    const formData = new FormData(form);
    const collectionId = form.dataset.collectionId;

    if (form.id === "FacetSearchForm" && collectionId) {
      if (formData.has("q") && formData.get("q") === "") {
        formData.delete("q");
      } else {
        FacetFiltersForm.endCursor = "";
        formData.append("collection_id", collectionId);
      }
    }
    return new URLSearchParams(formData).toString();
  }

  onSubmitForm(searchParams, event) {
    FacetFiltersForm.renderPage(searchParams, event);
  }

  onSubmitHandler(event) {
    event.preventDefault();
    const sortFilterForms = document.querySelectorAll("facet-filters-form form");
    
    if (event.srcElement.className == "mobile-facets__checkbox") {
      const forms = [];
      const searchParams = this.createSearchParams(event.target.closest("form"));
      forms.push(searchParams);

      const mobileSearchForm = document.querySelector("facet-filters-form #FacetSearchForm[data-apply-on='mobile']");
      if (mobileSearchForm) {
        forms.push(this.createSearchParams(mobileSearchForm));
      }
      
      const sortForm = document.querySelector("facet-filters-form #FacetSortForm[data-apply-on='mobile']");
      if (sortForm) {
        forms.push(this.createSearchParams(sortForm));
      }
      this.onSubmitForm(forms.join("&"), event);
    } else {
      const forms = [];
      const isMobile = event.target.closest("form").id === "FacetFiltersFormMobile";

      sortFilterForms.forEach((form) => {
        if (form.id === "FacetSearchForm") {          
          if (form.dataset.applyOn === "desktop" && window.innerWidth >= 750) {
            forms.push(this.createSearchParams(form));
          } else if (form.dataset.applyOn === "mobile" && window.innerWidth < 750) {
            forms.push(this.createSearchParams(form));
          }
        }
        
        if (!isMobile) {
          if (
            form.id === "FacetFiltersForm" ||
            form.id === "FacetSortDrawerForm"
          ) {
            forms.push(this.createSearchParams(form));
          }

          if (form.id === "FacetSortForm") {
            if (window.innerWidth < 750 && form.dataset.applyOn === "mobile") {
              forms.push(this.createSearchParams(form));
            } else if (
              window.innerWidth >= 750 &&
              form.dataset.applyOn === "desktop"
            ) {
              forms.push(this.createSearchParams(form));
            }
          }
        } else if (form.id === 'FacetFiltersFormMobile') {
          forms.push(this.createSearchParams(form));
        }
      });

      this.onSubmitForm(forms.join("&"), event);
    }
  }

  onActiveFilterClick(event) {
    event.preventDefault();
    FacetFiltersForm.toggleActiveFacets();
    const url =
      event.currentTarget.href.indexOf('?') == -1
        ? ''
        : event.currentTarget.href.slice(event.currentTarget.href.indexOf('?') + 1);
    FacetFiltersForm.renderPage(url);
  }
}

FacetFiltersForm.filterData = [];
FacetFiltersForm.searchParamsInitial = window.location.search.slice(1);
FacetFiltersForm.searchParamsPrev = window.location.search.slice(1);
FacetFiltersForm.endCursor = "";
customElements.define("facet-filters-form", FacetFiltersForm);
// FacetFiltersForm.setListeners();
window.FacetFiltersForm = FacetFiltersForm;

class PriceRange extends HTMLElement {
  constructor() {
    super();
    this.querySelectorAll('input').forEach((element) => {
      element.addEventListener('change', this.onRangeChange.bind(this));
      element.addEventListener('keydown', this.onKeyDown.bind(this));
    });
    this.setMinAndMaxValues();
  }

  onRangeChange(event) {
    this.adjustToValidValues(event.currentTarget);
    this.setMinAndMaxValues();
  }

  onKeyDown(event) {
    if (event.metaKey) return;

    const pattern = /[0-9]|\.|,|'| |Tab|Backspace|Enter|ArrowUp|ArrowDown|ArrowLeft|ArrowRight|Delete|Escape/;
    if (!event.key.match(pattern)) event.preventDefault();
  }

  setMinAndMaxValues() {
    const inputs = this.querySelectorAll('input');
    const minInput = inputs[0];
    const maxInput = inputs[1];
    if (maxInput.value) minInput.setAttribute('data-max', maxInput.value);
    if (minInput.value) maxInput.setAttribute('data-min', minInput.value);
    if (minInput.value === '') maxInput.setAttribute('data-min', 0);
    if (maxInput.value === '') minInput.setAttribute('data-max', maxInput.getAttribute('data-max'));
  }

  adjustToValidValues(input) {
    const value = Number(input.value);
    const min = Number(input.getAttribute('data-min'));
    const max = Number(input.getAttribute('data-max'));

    if (value < min) input.value = min;
    if (value > max) input.value = max;
  }
}

customElements.define('price-range', PriceRange);

class FacetRemove extends HTMLElement {
  constructor() {
    super();
    const facetLink = this.querySelector('a');
    facetLink.setAttribute('role', 'button');
    facetLink.addEventListener('click', this.closeFilter.bind(this));
    facetLink.addEventListener('keyup', (event) => {
      event.preventDefault();
      if (event.code.toUpperCase() === 'SPACE') this.closeFilter(event);
    });

    this.preserveSearch(facetLink);   
  }

  preserveSearch(facetLink) {
    
    const searches = new URLSearchParams(location.search);
    const q = searches.get('q');

    if (q) {
      facetLink.href = facetLink.href + '&q=' + q;
    }
  }

  closeFilter(event) {
    event.preventDefault();
    
    FacetFiltersForm.showLoadingState();
    
    const form = this.closest('facet-filters-form') || document.querySelector('facet-filters-form');
    form.onActiveFilterClick(event);
  }
}

customElements.define('facet-remove', FacetRemove);
